export enum ClientDetailTab {
  CLIENT_DATA = 'CLIENT_DATA',
  SALE_PRODUCTS = 'SALE_PRODUCTS',
  PURCHASE_PRODUCTS = 'PURCHASE_PRODUCTS',
  COMPANY_SUPPLIERS = 'COMPANY_SUPPLIERS'
}
